(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('paymentLinkActions', {
            templateUrl: 'app/admin/invoices/payment-link-actions/payment-link-actions.html',
            controller: PaymentLinkActionsController,
            bindings: {
                uuid: '<',
                message: '<',
                customerPhone: '<'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function PaymentLinkActionsController($window, InvoiceUtilsService) {
        var vm = this;

        vm.$onChanges = onChanges;
        vm.copyLink = copyLink;
        vm.accessLink = accessLink;
        vm.sendToWhatsApp = sendToWhatsApp;

        function onChanges() {
            vm.paymentLinkUrl = vm.uuid ? InvoiceUtilsService.buildPaymentLinkUrl(vm.uuid) : '';
            vm.whatsappMessage = (vm.message || '') + (vm.paymentLinkUrl ? '\n\n' + vm.paymentLinkUrl : '');
        }

        function copyLink() {
            InvoiceUtilsService.copyPaymentLink(vm.uuid);
        }

        function accessLink() {
            $window.open(vm.paymentLinkUrl, '_blank');
        }

        function sendToWhatsApp() {
            openWhatsAppShare(vm.whatsappMessage, vm.customerPhone);
        }
    }
})();
